export const CONSTANTS = {
  LANGUAGE_STORAGE_KEY: 'lang',
  LANGUAGE_DEFAULT: 'en',
  THEME_STORAGE_KEY: 'theme',
  THEME_DEFAULT: 'en',
  FORMAT_DATE: 'DD-MM-YYYY',
  NEWS_IMG_PATH: '/media/news/',
  EMENU_URL: 'https://online.fliphtml5.com/vnaircaterers/VACS-E-MENU/#p=1',
} as const;

export const getConstants = () => CONSTANTS;
